'use client'
import { Navigate } from 'react-router-dom'
import { useSearchParams, getTranslations } from '@/lib/next-shim'
import { PageTitle } from '@/shared/ui/seo/PageTitle'
import { filter } from 'lodash'
import { useGetMyInfosQuery } from '@/core/graphql/hooks'
import { ConsultationsFilterTabValue } from './ConsultationsFilterTabs'
import { ConsultationsList } from './ConsultationsList'

export function ConsultationsPage() {
  const searchParams = useSearchParams()
  const tab = searchParams?.get('tab') as ConsultationsFilterTabValue
  const t = getTranslations()

  const { data, loading, error } = useGetMyInfosQuery()
  const myInfos = data?.myInfos

  if (!tab) {
    return <Navigate to="?tab=past" replace />
  }

  if (loading) return <div className="p-10 text-center">{t('common.loading')}</div>
  if (error) return <div className="p-10 text-center text-red-500">{t('common.error', { message: error.message })}</div>

  const consultations = filter(myInfos?.consultations, (consultation) => {
    if (tab === 'past') return new Date(consultation.startDate) < new Date()
    return new Date(consultation.startDate) > new Date()
  })

  return (
    <div className="flex-1 overflow-auto p-2 sm:p-4 md:p-6">
      <PageTitle title={t('account.navigationMenu.accountConsultations.label')} />
      <h1 className="sr-only">{t('account.navigationMenu.accountConsultations.label')}</h1>
      <ConsultationsList consultations={consultations} tab={tab} />
    </div>
  )
}
